import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import PluscircleIcon from 'icons/Pluscircle.icon';
import { useTranslation } from 'react-i18next';
import PencilIcon from 'icons/Pencil.icon';
import { Button } from 'ncoded-component-library';
import { useField, useForm } from 'react-final-form';
import { isEnterPressed } from 'utils';

import './AddCustomRfiDocument.styles.scss';

type AddCustomRfiDocumentProps = {
  className?: string;
  name: string;
};

const MAX_LENGHT = 50;

const AddCustomRfiDocument: React.FC<AddCustomRfiDocumentProps> = (props) => {
  const { className, name } = props;

  const [isAdding, setIsAdding] = useState(false);
  const [value, setValue] = useState('');

  const { input } = useField(name);
  const { change } = useForm();

  const { t } = useTranslation();

  const classes = classNames(
    'add-custom-rfi-document',
    { adding: isAdding },
    className,
  );

  const disabled = useMemo(
    () =>
      value.length < 1 ||
      value.length > MAX_LENGHT ||
      input.value.some(
        (el: any) => el.name.toLowerCase() === value?.toLowerCase(),
      ),
    [input?.value, value],
  );

  const handleAddNew = useCallback(() => {
    if (disabled) return;

    change(name, [
      ...input.value,
      { name: value, checked: true, period: undefined },
    ]);

    setIsAdding(false);
    setValue('');
  }, [change, disabled, input, name, value]);

  if (!isAdding)
    return (
      <div className={classes} onClick={() => setIsAdding(true)}>
        <PluscircleIcon />
        {t('addCustomDocument')}
        <PencilIcon />
      </div>
    );

  return (
    <label className={classes}>
      <input
        autoFocus
        maxLength={MAX_LENGHT}
        value={value}
        placeholder={t('nameThisRequestBriefly')}
        onChange={({ target }) => setValue(target.value)}
        onKeyDown={(e) => {
          if (isEnterPressed(e)) {
            handleAddNew();
          }
        }}
      />

      <div>
        <p>{t('remainingChars', { count: MAX_LENGHT - value.length })}</p>
        <Button variant="outline" disabled={disabled} onClick={handleAddNew}>
          {t('save')}
        </Button>
      </div>
    </label>
  );
};

export default AddCustomRfiDocument;
